import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import FeaturesList from './components/FeaturesList';
// import Stats from './components/Stats'; // Temporarily commented out
import TeamSection from './components/TeamSection';
import CommitmentSection from './components/CommitmentSection';
import Testimonial from './components/Testimonial';
import Footer from './components/Footer';
import Contact from './components/Contact';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={
            <main>
              <Hero />
              <FeaturesList />
              {/* <Stats /> */}
              <TeamSection />
              <CommitmentSection />
              <Testimonial />
            </main>
          } />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
